import request from '@/utils/request';
// 获取直播人列表
const getStreamerList = (id,params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/list`,
        data: params,
        method: 'get'
    });
};
// 获取直播人列表数量
const getStreamerListCount = (id,params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/count`,
        data: params,
        method: 'get'
    });
};
// 添加直播人
const addStreamerList = (id,params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/livePresenter`,
        data: params,
        method: 'post'
    });
};
// 编辑直播人
const editStreamerList = (id, meetingId, params) => {
    return request({
         url: `/gathering/meeting/${meetingId}/invitee/livePresenter/${id}`,
        data: params,
        method: 'put'
    });
};
// 批量添加直播人
const addsStreamerList = (id,params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/live-streaming/list`,
        data: params,
        method: 'post'
    });
};
export {
	getStreamerList,
	getStreamerListCount,
	addStreamerList,
	editStreamerList,
	addsStreamerList,
};
